
import { Component, Emit, Vue } from 'vue-property-decorator';
import { Color, colorClass } from '../model/colors';

@Component
export default class Palette extends Vue {
  private colors = [...Array(16).keys()];
  private selected = { color: 1 };
  private isCompact = false;
  private colorClass = colorClass;

  @Emit('color')
  public colorSelected(color: Color): Color {
    this.selected.color = color;
    return color;
  }

  protected mounted() {
    this.colorSelected(this.selected.color);
    this.handleResize();
    window.addEventListener('resize', this.throttle(this.handleResize, 100));
  }

  protected beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }

  private handleResize() {
    this.isCompact = window.innerWidth <= 768;
  }

  private isSelected(color: Color): boolean {
    return color === this.selected.color;
  }

  private throttle(func: Function, limit: number) {
    let inThrottle: boolean;
    return function(this: any, ...args: any[]) {
      if (!inThrottle) {
        func.apply(this, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    }
  }
}
